import { useEffect, useRef } from "react";

const EMBED_ID = "vidalytics_embed_u9032guPE8CmWRPm";
const EMBED_BASE = "https://fast.vidalytics.com/embeds/GH1yI8Q2/u9032guPE8CmWRPm/";

/**
 * Vidalytics VSL player. The vendor snippet is injected on mount (instead of a
 * raw <script> tag in JSX) so the player initializes when this route renders.
 */
export function VidalyticsEmbed() {
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const s = document.createElement("script");
    s.type = "text/javascript";
    s.text = `(function (v, i, d, a, l, y, t, c, s) {
y='_'+d.toLowerCase();c=d+'L';if(!v[d]){v[d]={};}if(!v[c]){v[c]={};}if(!v[y]){v[y]={};}var vl='Loader',vli=v[y][vl],vsl=v[c][vl + 'Script'],vlf=v[c][vl + 'Loaded'],ve='Embed';
if (!vsl){vsl=function(u,cb){
if(t){cb();return;}s=i.createElement("script");s.type="text/javascript";s.async=1;s.src=u;
if(s.readyState){s.onreadystatechange=function(){if(s.readyState==="loaded"||s.readyState=="complete"){s.onreadystatechange=null;vlf=1;cb();}};}else{s.onload=function(){vlf=1;cb();};}
i.getElementsByTagName("head")[0].appendChild(s);
};}
vsl(l+'loader.min.js',function(){if(!vli){var vlc=v[c][vl];vli=new vlc();}vli.loadScript(l+'player.min.js',function(){var vec=v[d][ve];t=new vec();t.run(a);});});
})(window, document, 'Vidalytics', '${EMBED_ID}', '${EMBED_BASE}');`;
    document.body.appendChild(s);
    return () => {
      s.remove();
    };
  }, []);

  return <div id={EMBED_ID} style={{ width: "100%", position: "relative", paddingTop: "56.25%" }} />;
}
